/**
 * WooCommerce Add to Cart Handler with Upsell Modal
 * Improved version with better error handling and code consistency
 */
(function () {
  "use strict";

  // ----------------------------------------------------
  // AFTER ADD TO CART CATALOG
  // ----------------------------------------------------
  jQuery(document).on("added_to_cart", function (event, fragments, cart_hash, button) {
    const params = kubelio_add_to_cart_params;
    kubelioNotify(params.added_success_text, 1800);
  });
})();
